<!--<mat-card id="card-skill" style="padding-bottom: 5%;background-color: #112c41 ;">-->




  <h1 style="margin-top: 6%; color: #E0FFFF;  font-family: 'Syne Mono', monospace; font-size: 30px;"><b>COMPETENZE</b></h1>
 <div class="row">
    <div class="col-xs-12 col-sm-4 col-md-2 box rotate">
      <img id="pesi"  src="/assets/pesi.jpg" alt="Logo" class="img-thumbnail" >
    </div>
    <div class="col-xs-12 col-sm-4 col-md-6">  <p class="skill" style="margin-right: 0px;">
        Personal Trainer Fitness & Bodybuilding:
      per la creazione di percorsi individuali che mirino ad esigenze
      di dimagrimento, ipertrofia, forza, resistenza, ricomposizione corporea.
    </div>
    <div class="col-xs-12 col-sm-12 col-md-4"></div>



    <div class="col-xs-12 col-sm-4 col-md-2 box rotate" style="margin-top: 7%">
      <img id="cibo"  src="/assets/cibo.jpg" alt="Logo" class="img-thumbnail">
    </div>
    <div class="col-xs-12 col-sm-4 col-md-6" style="margin-top: 7%">
      <p class="skill">
        Educatore in Nutrizione Funzionale:
      per indirizzarti in una corretta e mirata alimentazione e integrazione,
        tramite delle semplici e rapide linee guida che rispecchiano l’obiettivo da te prefissato.
      </p>
    </div>
    <div class="col-xs-12 col-sm-4 col-md-4" style="margin-top: 7%"></div>


  <div class="col-xs-12 col-sm-4 col-md-2 box rotate"  style="margin-top: 7%">
    <img id="esercizio"  src="/assets/esercizio.jpg" alt="Logo" class="img-thumbnail"></div>
  <div class="col-xs-12 col-sm-4 col-md-6" style="margin-top: 7%">
    <p class="skill">
    Specialista in Esercizio Correttivo:
    per la creazione di percorsi d’allenamento che abbiano come obiettivo la correzione di scompensi muscolari, posturali, riabilitazione motoria ed aumento della propriocezione. Esso può anche essere integrato in un percorso di Fitness o Bodybuilding per andare ad interagire su diversi aspetti ed obiettivi.
    </p>
  </div>
    <div class="col-xs-12 col-sm-4 col-md-4" style="margin-top: 7%"></div>

    <div class="col-xs-12 col-sm-4 col-md-2 box rotate" style="margin-top: 7%"><img id="taping"  src="/assets/taping.jpg" alt="Logo" class="img-thumbnail"></div>
    <div class="col-xs-12 col-sm-4 col-md-6" style="margin-top: 7%">    <p class="skill">
      Specialista nell’applicazione di Taping Elastico:
      per bendaggi di Taping Elastico di grande utilità in ambito terapeutico, sportivo, ortopedico e traumatologico, in quanto è in grado di: drenare e scaricare tendini, muscoli e zone sottocutanee da infiammazioni, traumi e ristagno di liquidi in eccesso; Supportare legamenti e capi tendinei articolari; Aumento della propriocezione; Contribuire significativamente nella correzione di posture errate; Stimoli muscolari costanti in fase di competizioni sportive; Accelerare i tempi di recupero da infortuni (stiramenti, strappi, contratture).
    </p></div>
    <div class="col-xs-12 col-sm-4 col-md-4" style="margin-top: 7%"></div>



    <div class="col-xs-12 col-sm-4 col-md-2 box rotate" style="margin-top: 7%"><img id="massaggiatore"  src="/assets/massaggio.jpg" alt="Logo" class="img-thumbnail"></div>
    <div class="col-xs-12 col-sm-4 col-md-6" style="margin-top: 7%">    <p class="skill">
      Massaggiatore Sportivo:
      trattamenti di massaggio sportivo dediti all’aumento della performance nel pre ed intra di una competizione e defaticanti nel post competizione.
    </p></div>
    <div class="col-xs-12 col-sm-4 col-md-4" style="margin-top: 7%"></div>


  </div>

  <p  style="margin-top: 5%; color: #E0FFFF;  font-family: 'Syne Mono', monospace; font-size: 20px;">
    QUINDI COSA ASPETTI?
  </p>
  <p style=" color: #E0FFFF;  font-family: 'Syne Mono', monospace; font-size: 20px;">
    CONTATTAMI, INSIEME TROVEREMO IL PERCORSO ADATTO ALLE TUE ESIGENZE!
  </p>


<!--</mat-card>-->
